/**
 * Última búsqueda abierta en esta pestaña, para que "Volver" desde un aviso regrese a
 * ella. Solo se guarda el id de la búsqueda (nunca el texto buscado), en
 * sessionStorage: muere al cerrar la pestaña.
 */

const KEY = "sentinel:last-search";

export function rememberSearch(path: string): void {
  try {
    sessionStorage.setItem(KEY, path);
  } catch { /* almacenamiento bloqueado: Volver cae a /buscar */ }
}

/** Posición del scroll en los resultados de una búsqueda (para volver desde un aviso). */
export function saveSearchScroll(searchId: string, y: number): void {
  try {
    sessionStorage.setItem(`${KEY}:scroll:${searchId}`, String(Math.round(y)));
  } catch { /* sin almacenamiento: se vuelve arriba */ }
}

export function searchScroll(searchId: string): number | null {
  try {
    const n = Number(sessionStorage.getItem(`${KEY}:scroll:${searchId}`));
    return Number.isFinite(n) && n > 0 ? n : null;
  } catch {
    return null;
  }
}

export function lastSearchUrl(): string | null {
  try {
    const v = sessionStorage.getItem(KEY);
    return v && v.startsWith("/buscar") ? v : null;
  } catch {
    return null;
  }
}
